'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _flattenProp = require('recompose/flattenProp');

var _flattenProp2 = _interopRequireDefault(_flattenProp);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _dropdowns = require('./dropdowns');

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectDropdown(state, props) {
  var dropdowns = state.dropdowns;
  var reference = props.reference;
  var _dropdowns$reference = dropdowns[reference],
      dropdown = _dropdowns$reference === undefined ? {} : _dropdowns$reference;
  var _dropdown$options = dropdown.options,
      options = _dropdown$options === undefined ? [] : _dropdown$options,
      _dropdown$updatedAt = dropdown.updatedAt,
      updatedAt = _dropdown$updatedAt === undefined ? null : _dropdown$updatedAt;


  return {
    options: options,
    updatedAt: updatedAt
  };
}
function makeHandlers(dispatch, props) {
  var reference = props.reference;


  return {
    setOptions: function setOptions(options) {
      return dispatch(_dropdowns.actions.setOptions({
        reference: reference,
        options: options,
        timestamp: new Date() }));
    }
  };
}

var shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _getContext2.default)({ server: object }), (0, _injectProps2.default)({
  schema: shape({
    reference: string.isRequired
  }).isRequired
}), (0, _flattenProp2.default)('schema'), (0, _reactRedux.connect)(selectDropdown, makeHandlers), (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    var options = this.props.options;

    if (options.length === 0) {
      var _props = this.props,
          server = _props.server,
          reference = _props.reference,
          setOptions = _props.setOptions;
      // TODO fetchOptions with updatedAt

      server.fetchOptions({ reference: reference }).then(setOptions).catch(function (error) {
        if (error.message !== 'isFetching') throw error;
      });
    }
  }
}), (0, _exposeProps2.default)(['options']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'controlFetchOptions');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/connectOptionsFromStore.js
// module id = 1639
// module chunks = 0